// Control keys of the internal FormGroup — also bound from the template via [formControlName].
export const DATE_RANGE_CONTROL = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  TOTAL_DAYS: 'totalDays',
} as const;

// Statuses that keep the start picker editable (any other non-empty status disables it).
export const DATE_RANGE_STATUS = {
  SCHEDULED: 'SCHEDULED',
} as const;

export const DATE_RANGE_LABEL = {
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
} as const;

export const DATE_RANGE_MESSAGE = {
  /** Campaign-manager note; maxDays = days + 1 (the range spans both boundary days). */
  campaignDuration: (maxDays: number): string => `Campaign duration must not exceed ${maxDays} days`,
  clearStartDate: 'Clear \'Start Date\' date',
  clearEndDate: 'Clear \'End Date\' date',
  clearDate: 'Clear date',
} as const;
